export interface BackoffOptions {
  baseMs: number;
  maxMs: number;
  factor: number;
  /** 0..1: the share of each delay that is randomised. */
  jitter: number;
}

export const DEFAULT_BACKOFF: BackoffOptions = { baseMs: 500, maxMs: 15_000, factor: 2, jitter: 0.5 };

/**
 * Delay before retry number `attempt` (0-based). Exponential growth capped at
 * `maxMs`; the jittered part spreads clients that lost the same server so they
 * do not all return in the same instant, while the fixed part keeps a floor.
 */
export function backoffDelay(
  attempt: number,
  options: BackoffOptions = DEFAULT_BACKOFF,
  random: () => number = Math.random,
): number {
  const exponent = Math.max(0, Math.floor(attempt));
  // 2 ** 64 is already beyond any sane cap; bounding the exponent avoids Infinity * 0 style surprises.
  const ceiling = Math.min(options.maxMs, options.baseMs * options.factor ** Math.min(exponent, 64));
  const jitter = Math.min(1, Math.max(0, options.jitter));
  return Math.round(ceiling * (1 - jitter + jitter * random()));
}
